/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * What type of deletion was the file deletion.
 */
export const DeletionType = /* #__PURE__ */ parsers.exactly('empty_directory', 'denied_file', 'leading_directory');
